import { ReadyProductService } from './../../../../Services/Ready-Product/ready-product.service';
import { OtherProductService } from '../../../../Services/OtherProduct/other-product.service';
import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { TaggingService } from '../../../../Services/Tagging/tagging.service';
import { HttpParams } from '@angular/common/http';
import { CategoryService } from '../../../../Services/Category/category.service';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';
import { RateListGeneratorService } from '../../../../Services/Rate_List_Generator/rate-list-generator.service';
import { RouterLink, Router } from '@angular/router';
import { OnlyNumberDirective } from '../../../../shared/only-number.directive';
import Swal from 'sweetalert2';
import { environment } from '../../../../../environments/environment';
import { WeightScaleService } from '../../../../Services/WeightScale/weight-scale.service';

@Component({
  selector: 'app-product-tagging',
  standalone: true,
  imports: [NgIf, NgFor, NgClass, FormsModule, ReactiveFormsModule, RouterLink, OnlyNumberDirective],
  templateUrl: './product-tagging.component.html',
  styleUrl: './product-tagging.component.css',
})
export class ProductTaggingComponent implements OnInit, OnDestroy {
  productTaggingForm!: FormGroup;
  weighingScaleEnabled = false;
  weighingScaleSetting: any = null;
  autoWeightInterval: any = null;
  completedProductCodes: any[] = [];
  productTaggingDataList: any;
  selectedFirm: any;
  completeProductData: any;
  data: any[] = [];
  readyProductDataList: any[] = [];
  highlightedIndex = -1;
  rateListCodes: any[] = [];
  barcodeValue: any;
  showRateListCodeField = true;
  prefixSettings: any = null;
  barcodePrefix: string = '';
  private weightWatcherInitialized = false;
  selectedCategoryName: string = '';
  selectedCategory: any = null;
  hideInputsForProduct: boolean = true;

  mergedTemplates: any[] = [];
  dbTemplates: any[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService,
    private tagginsService: TaggingService,
    private readyProductService: ReadyProductService,
    private categoryService: CategoryService,
    private customizeService: CustomizeService,
    private rateListService: RateListGeneratorService,
    private otherProductService: OtherProductService,
    private weightScaleService: WeightScaleService
  ) { }

  ngOnInit(): void {
    const activeFirm = this.firmSelectionService.getselectedFirmName();
    if (activeFirm && activeFirm.id) {
      this.selectedFirm = activeFirm.id;
    }

    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      if (firm && firm.id) {
        this.selectedFirm = firm.id;
        this.initForm();
        this.refreshFirmRelatedData();
        this.getCustomeTemplateType(firm.id);
        this.getAndSetBarcode();
      }
    });

    this.initForm();
    this.refreshFirmRelatedData();
    if (this.selectedFirm) {
      this.getCustomeTemplateType(this.selectedFirm);
    }
    this.loadWeighingScaleSettings();
  }

  ngOnDestroy(): void {
    this.stopAutoWeight();
  }

  private refreshFirmRelatedData(): void {
    this.getReadyProductList();
    this.fetchRateListCodes();
    this.getAndSetBarcode();
  }

  initForm() {
    this.productTaggingForm = this.fb.group({
      std_barcode: [''],
      std_item_code: [''],
      std_model_no: [''],
      std_item_category: [''],
      std_stone_type: [''],
      std_applied_tag: ['', Validators.required],
      std_item_size: [''],
      std_rate_list_code: [''],
      std_unit_price: [''],
      std_image: [''],
      std_total_wt: [''],
      std_product_type: ['piece-wise'],
      std_firm_id: this.selectedFirm,
    });
  }
  isPrefixConfigured(): boolean {
    // adjust keys based on what your API returns
    return !!(
      this.prefixSettings &&
      this.prefixSettings.ready_product_prefix &&
      this.prefixSettings.ready_product_prefix.trim() !== ''
    );
  }

  getCustomeTemplateType(firmId: any) {
    this.customizeService.getBarcodeTemplates(firmId)
      .subscribe((res: any) => {

        this.dbTemplates = res?.data || [];

        // Convert DB templates into same format
        const formattedDbTemplates = this.dbTemplates.map((t: any) => ({
          value: t.name,
          name: t.name
        }));

        // Remove duplicates (if DB has same name as default)
        const uniqueDbTemplates = formattedDbTemplates;

        // Merge default + DB
        this.mergedTemplates = [
          ...uniqueDbTemplates
        ];

      });
  }

  getDataForModelNo(itemCode: any) {
    this.tagginsService
      .getTaggingsDataOnItemCode(itemCode)
      .subscribe((res: any) => {
        const itemCodeLength = res.data?.length || 0;

        // Patch std_model_no with itemCode + '#' + (length + 1)
        const newModelNo = `${itemCode}-${itemCodeLength + 1}`;
        this.productTaggingForm.patchValue({
          std_model_no: newModelNo,
        });
      });
  }

  getReadyProductList() {

  let params = new HttpParams()
    .append('ready_product_type[]', 'piece-wise')
    .append('ready_product_type[]', 'assembly')
    .set('quantity_greater_than', '0');

  this.readyProductService.getReadyProducts(params).subscribe({

    next: (res: any) => {

      const list = res?.data.reverse() || [];

      this.readyProductDataList = list
  .filter((p: any) => Number(p?.rproduct_quantity) > 0)
  .map((p: any) => {
    
    // 1. Use the correct property name from your DB: 'rproduct_image'
    const fileName = p.rproduct_image;

    if (fileName) {
      /** 
       * 2. Determine the correct folder. 
       * Based on your DB: 
       * - Files starting with 'product_image_' usually live in '/products/'
       * - Files starting with 'rproduct_' usually live in '/ready-products/'
       */
      let folder = 'ready-products'; 
      
      if (fileName.startsWith('product_image_')) {
        folder = 'products';
      }

      // 3. Construct the full storage path so the proxy function can recognize it
      const fullStoragePath = `/storage/${folder}/${fileName}`;

      // 4. Run it through your proxy helper
      p.rproduct_image = this.proxyImageUrl(fullStoragePath);
    }

    return p;
  })

        .sort((a: any, b: any) => {
          const dateA = new Date(a?.updated_at || 0).getTime();
          const dateB = new Date(b?.updated_at || 0).getTime();
          return dateB - dateA;
        });

    },

    error: () => {
      this.notificationService.showError(
        'Failed to load ready product list.',
        'Error'
      );
    },

  });
}
/* ============================================================
     IMAGE PROXY HELPERS
  ============================================================ */

  proxyImageUrl(url: string): string {
    if (!url) return url;
    if (url.includes('/api/image-proxy/')) return url;
    const match = url.match(/\/storage\/(.+)$/);
    if (!match) return url;
    const backendBase = environment.apiBaseUrl.replace(/\/api\/$/, '');
    return `${backendBase}/api/image-proxy/${match[1]}`;
  }

  addProductTaggingData() {
    if (!this.productTaggingForm.get('std_applied_tag')?.value) {
      this.productTaggingForm.get('std_applied_tag')?.markAsTouched();
      this.notificationService.showError('Please select Tag Type.', 'Validation Error');
      return;
    }

    if (!this.productTaggingForm.get('std_item_code')?.value) {
      this.notificationService.showError('Please select a product from the list below to start tagging.', 'Validation Error');
      return;
    }

    if (this.productTaggingForm.invalid) {
      this.productTaggingForm.markAllAsTouched();
      this.notificationService.showError('Please fill in all required fields.', 'Validation Error');
      return;
    }

    const payload = this.productTaggingForm.getRawValue();

    this.tagginsService.createStockDetails(payload).subscribe({
      next: (res: any) => {
        this.notificationService.showSuccess(
          'Product Tagged Successfully!',
          'Success'
        );

        const updatedItemCode = res.data?.std_item_code;
        const taggedQty = Number(
          res.data?.std_quantity ?? payload.std_quantity ?? 1
        );

        if (
          this.selectedProduct &&
          this.selectedProduct.rproduct_code === updatedItemCode
        ) {
          const currentQty = Number(
            this.selectedProduct.rproduct_quantity || 0
          );
          const newQty = currentQty - taggedQty;
          this.selectedProduct.rproduct_quantity = newQty;

          this.readyProductDataList = (this.readyProductDataList || []).map(
            (p: any) => {
              if (p.rproduct_code === updatedItemCode) {
                return { ...p, rproduct_quantity: newQty };
              }
              return p;
            }
          );

          if (newQty <= 0) {
            this.readyProductDataList = this.readyProductDataList.filter(
              (p: any) => Number(p.rproduct_quantity) > 0
            );
            this.selectedProduct = null;
            this.clearForm();
          }
        }

        this.readyProductService.getReadyProducts(new HttpParams().set('ready_product_type', 'piece-wise').set('quantity_greater_than', '0'))
          .subscribe({
            next: (productRes: any) => {
              const updatedList = (productRes.data.reverse() || [])
                .filter((p: any) => Number(p.rproduct_quantity) > 0)
                .sort(
                  (a: any, b: any) =>
                    new Date(b.created_at).getTime() -
                    new Date(a.created_at).getTime()
                );

              this.readyProductDataList = updatedList;

              const updatedProduct = updatedList.find(
                (p: any) => p.rproduct_code === updatedItemCode
              );

              if (updatedProduct) {
                this.selectedProduct = updatedProduct;
                this.onStart(updatedProduct);
              } else {
                this.selectedProduct = null;
                this.clearForm();
              }

              this.getAndSetBarcode();
            },
            error: () => {
              this.notificationService.showError(
                'Failed to refresh product list after tagging.',
                'Error'
              );
            },
          });
      },
      error: (error: any) => {
        let errorMessage = 'Failed to tag product.';
        if (error.error?.errors) {
          const errors = error.error.errors;
          const messages: string[] = [];
          for (const key of Object.keys(errors)) {
            let list = Array.isArray(errors[key]) ? errors[key] : [errors[key]];
            list = list.map((m: any) => String(m).replace('std applied tag', 'Tag Type').replace('std_applied_tag', 'Tag Type'));
            messages.push(...list);
          }
          if (messages.length > 0) {
            errorMessage = messages.join('\n');
          }
        } else if (error.error?.message) {
          errorMessage = String(error.error.message).replace('std applied tag', 'Tag Type').replace('std_applied_tag', 'Tag Type');
        }
        this.notificationService.showError(errorMessage, 'Validation Error');
      },
    });
  }

  clearForm() {
    this.productTaggingForm.reset({
      std_firm_id: this.selectedFirm,
      std_item_code: '',
      std_barcode: '',
      std_product_type: 'piece-wise',
    });
    this.completeProductData = null;
    this.selectedProduct = null;
    this.getAndSetBarcode();
  }

  getAndSetBarcode() {
    this.customizeService.getCustomizeSettings().subscribe({
      next: (response: any) => {
        if (response?.data?.length > 0) {
          const settings = response.data[response.data.length - 1];

          // STORE PREFIX FOR LATER CHECK
          this.barcodePrefix = settings?.customize_barcode_prefix || '';

          if (this.barcodePrefix) {
            this.customizeService.getNextBarcode(this.barcodePrefix).subscribe({
              next: (res: any) => {
                if (res?.code) {
                  this.productTaggingForm.patchValue({
                    std_barcode: res.code
                  });
                }
              }
            });
          }
        }
      },
      error: () => {
        this.barcodePrefix = '';
      }
    });
  }

  focusNext(event: Event) {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();
    const target = keyboardEvent.target as HTMLElement;
    const form = target.closest('form');
    if (!form) return;
    const focusableElements = Array.from(
      form.querySelectorAll<HTMLElement>('input, select, textarea, button')
    ).filter(
      (el) =>
        !el.hasAttribute('disabled') &&
        !el.hasAttribute('readonly') &&
        el.tabIndex !== -1 &&
        el.offsetParent !== null
    );
    const currentIndex = focusableElements.indexOf(target);
    if (currentIndex !== -1 && currentIndex + 1 < focusableElements.length) {
      focusableElements[currentIndex + 1].focus();
    }
  }

  mrp: any;
  length: any;
  showWeightField = false;
  selectedProduct: any;

  onStart(metal: any): void {

    // BLOCK TAGGING IF PREFIX NOT CONFIGURED
    if (!this.barcodePrefix || this.barcodePrefix.trim() === '') {

      Swal.fire({
        title: 'Configuration Required',
        html: `
        <p class="text-gray-600 text-sm">
          Product code prefix is not configured.<br/>
          Please set the prefix before tagging products.
        </p>
      `,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Set Prefix',
        cancelButtonText: 'Cancel',
        backdrop: `rgba(0,0,0,0.4) blur(6px)`,
        customClass: {
          popup: 'rounded-2xl shadow-2xl p-6',
          confirmButton:
            'bg-[#c19725] text-white rounded-md px-4 py-2 hover:bg-[#a87f1f]',
          cancelButton:
            'bg-gray-200 text-gray-800 rounded-md px-4 py-2 hover:bg-gray-300',
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.isConfirmed) {
          // Redirect ONLY when user clicks "Set Prefix"
          this.router.navigateByUrl('/admin-panel/dropdown-setting');
        }
      });

      return; //  STOP tagging flow
    }

    if(metal.rproduct_stock_type === 'Product'){
      this.hideInputsForProduct = false;
    }else{
      this.hideInputsForProduct = true;
    }

    this.getDataForModelNo(metal.rproduct_code);
    this.selectedProduct = metal;

    this.selectedCategory = metal.rproduct_categories;
    this.applyCategoryUnitRules(this.selectedCategory);
    this.weightWatcherInitialized = false;
    
    const catparams = new HttpParams().set('id',metal.rproduct_categories?.id);
    this.categoryService
      .getCategories(catparams)
      .subscribe((res: any) => {
        const category = res?.data?.[0];
        
        const mrpValue = parseFloat(category?.mrp);
        this.mrp = Number(isNaN(mrpValue) ? 0 : Math.round(mrpValue));

        const unit = this.selectedCategory?.unit;

        if (unit === 'By MRP') {
                
          const unitPriceControl = this.productTaggingForm.get('std_unit_price');
                
          if (metal?.rproduct_stock_type === 'Product') {
          
            const productParams = new HttpParams().set('product_code', metal.rproduct_code);
            this.otherProductService.getOtherProducts(productParams).subscribe((productRes: any) => {
              const productData = productRes?.data?.[0];
              const sellingPrice = Number(productData?.selling_price || 0);
              unitPriceControl?.setValue(sellingPrice);
              unitPriceControl?.disable();
            });
          
          } else {
          
            unitPriceControl?.reset();
            unitPriceControl?.enable();    // ✅ Make sure it's enabled if not Product
          
          }
        } else if (!this.showWeightField) {
          // fixed price categories
          this.productTaggingForm.get('std_unit_price')?.setValue(this.mrp);
        } else {
          this.productTaggingForm.get('std_total_wt')?.reset();
          this.productTaggingForm.get('std_unit_price')?.reset();
        }

        this.tagginsService
          .getTaggingsDataOnItemCode(metal.rproduct_code)
          .subscribe((tagRes: any) => {
            this.productTaggingForm.patchValue({
              std_item_code: metal.rproduct_code,
              std_item_category: metal.rproduct_categories?.id, 
              std_stone_type: metal.rproduct_stonetype || '',
              std_item_size: metal.rproduct_size || '',
              std_image: metal.rproduct_image || '',
            });
            this.selectedCategoryName = metal.rproduct_categories?.name || '';
            this.selectedCategory = metal.rproduct_categories;
            this.setupWeightWatcher();
          });
      });
  }

  applyCategoryUnitRules(category: any): void {
    const unit = category?.unit;

    switch (unit) {
      case 'By Silver Rate':
        this.showWeightField = true;
        this.showRateListCodeField = false;
        break;

      case 'By MRP':
        this.showWeightField = false;
        this.showRateListCodeField = false;
        break;

      case 'By Gram':
      default:
        this.showWeightField = true;
        this.showRateListCodeField = true;
        break;
    }
  }


  private getCategoryRanges(categoryId: any): string[] {
    return this.rateListCodes
      .filter(
        (rate: any) =>
          String(rate.rlg_product_category) === String(categoryId)
      )
      .map((rate: any) => {
        const min = rate.rlg_min_weight_range ?? '';
        const max = rate.rlg_max_weight_range ?? '';

        if (rate.rlg_above === 'Yes' && rate.rlg_below === 'Yes') {
          return 'All weights';
        }

        if (min !== '' && max !== '') {
          return `${min} – ${max} gm`;
        }

        if (min !== '') {
          return `Above ${min} gm`;
        }

        if (max !== '') {
          return `Below ${max} gm`;
        }

        return '';
      })
      .filter(Boolean);
  }

  setupWeightWatcher(): void {
  if (this.weightWatcherInitialized) return;
  this.weightWatcherInitialized = true;

  const weightControl = this.productTaggingForm.get('std_total_wt');
  if (!weightControl) return;

  weightControl.valueChanges.subscribe((weight: string) => {
    const weightValue = Number(weight) || 0;
    
    // 1. Basic Validation: If weight is 0, clear fields
    if (weightValue <= 0) {
      this.productTaggingForm.patchValue(
        { std_rate_list_code: '', std_unit_price: '' },
        { emitEvent: false }
      );
      return;
    }

    // 2. PRICE CALCULATION: Weight * Category MRP
    // We use 'this.mrp' which was set in the onStart() method
    if (this.mrp > 0) {
      const calculatedPrice = +(weightValue * this.mrp).toFixed(2);
      
      this.productTaggingForm.get('std_unit_price')?.setValue(calculatedPrice, { 
        emitEvent: false 
      });
      
    }

    // 3. RATE LIST MATCHING (Keep your existing range logic here)
    const currentCategoryId = this.productTaggingForm.get('std_item_category')?.value;
    if (currentCategoryId && this.rateListCodes.length) {
      const categoryRates = this.rateListCodes.filter(
        (rate: any) => String(rate.rlg_product_category) === String(currentCategoryId)
      );

      let matchedRate = categoryRates.find((rate: any) => {
        const min = rate.rlg_min_weight_range !== null ? Number(rate.rlg_min_weight_range) : null;
        const max = rate.rlg_max_weight_range !== null ? Number(rate.rlg_max_weight_range) : null;
        
        // Match Exact Range
        if (min !== null && max !== null) return weightValue >= min && weightValue <= max;
        // Match Above Only
        if (rate.rlg_above === 'Yes' && min !== null) return weightValue >= min;
        // Match Below Only
        if (rate.rlg_below === 'Yes' && max !== null) return weightValue <= max;
        // Match All
        if (rate.rlg_above === 'Yes' && rate.rlg_below === 'Yes') return true;
        
        return false;
      });

      if (matchedRate) {
        this.productTaggingForm.patchValue(
          { std_rate_list_code: matchedRate.rlg_code },
          { emitEvent: false }
        );
      } else {
        this.productTaggingForm.patchValue({ std_rate_list_code: '' }, { emitEvent: false });
      }
    }
  });
}


  filteredRateListCodes: any[] = [];
  showRateDropdown = false;

  fetchRateListCodes() {
    this.rateListService.getRateList().subscribe({
      next: (res: any) => {
        const codes = res?.data || [];
        this.rateListCodes = codes;
        this.filteredRateListCodes = [...codes];
      },
      error: (err) => console.error('Rate list fetch error:', err),
    });
  }

  onRateListCodeInputChange(event: any) {
    const input = event.target.value.toLowerCase();
    this.filteredRateListCodes = this.rateListCodes.filter((item) =>
      item.rlg_code?.toLowerCase().includes(input)
    );
    this.showRateDropdown = true;
    this.highlightedIndex = -1;
  }

  selectRateListCode(code: string) {
    this.productTaggingForm.get('std_rate_list_code')?.setValue(code);
    this.filteredRateListCodes = [];
    this.showRateDropdown = false;
    this.highlightedIndex = -1;
  }

  hideDropdownWithDelay() {
    setTimeout(() => {
      this.showRateDropdown = false;
    }, 200);
  }

  onRateListKeydown(event: KeyboardEvent) {
    if (this.showRateDropdown && this.filteredRateListCodes.length > 0) {
      if (event.key === 'ArrowDown') {
        this.highlightedIndex =
          (this.highlightedIndex + 1) % this.filteredRateListCodes.length;
        event.preventDefault();
      } else if (event.key === 'ArrowUp') {
        this.highlightedIndex =
          (this.highlightedIndex - 1 + this.filteredRateListCodes.length) %
          this.filteredRateListCodes.length;
        event.preventDefault();
      } else if (event.key === 'Enter') {
        if (this.highlightedIndex >= 0) {
          const selected = this.filteredRateListCodes[this.highlightedIndex];
          this.selectRateListCode(selected.rlg_code);
          event.preventDefault();
        } else {
          this.focusNext(event);
        }
      } else if (event.key === 'Escape') {
        this.showRateDropdown = false;
      }
    } else if (event.key === 'Enter') {
      this.focusNext(event);
    }
  }

  loadWeighingScaleSettings(): void {
    this.weightScaleService.getSettings().subscribe({
      next: (res: any) => {
        if (res && res.data) {
          this.weighingScaleSetting = res.data;
          this.weighingScaleEnabled = !!res.data.enabled;
          
          if (this.weighingScaleEnabled) {
            if (res.data.com_port === 'BROWSER_DIRECT') {
              this.weightScaleService.autoConnectDirectBrowserSerial(
                parseInt(res.data.data_rate) || 9600,
                parseInt(res.data.calibration) || 1
              ).then(success => {
                if (success) {
                  console.log('Connected to browser serial port automatically.');
                }
              });
            } else {
              const ownerId = res.data.owner_id || 1;
              this.weightScaleService.initializeLocalAgent(ownerId).subscribe();
            }
          }
        }
      }
    });
  }

  @HostListener('window:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    if (this.weighingScaleEnabled && event.ctrlKey && event.key === 'F2') {
      event.preventDefault();
      this.fetchWeightFromScale();
    }
  }

  fetchWeightFromScale() {
    this.weightScaleService.getWeightFromAgent().subscribe(res => {
      if (res && res.success && res.weight !== undefined) {
        this.productTaggingForm.patchValue({
          std_total_wt: res.weight
        });
        this.notificationService.showSuccess(`Fetched weight: ${res.weight}g`, 'Success');
      } else {
        this.notificationService.showError('Could not fetch weight from weighing scale', 'Error');
      }
    });
  }

  startAutoWeight() {
    if (!this.weighingScaleEnabled) return;
    this.stopAutoWeight();
    this.autoWeightInterval = setInterval(() => {
      this.weightScaleService.getWeightFromAgent().subscribe(res => {
        if (res && res.success && res.weight !== undefined) {
          this.productTaggingForm.patchValue({
            std_total_wt: res.weight
          });
        }
      });
    }, 1000);
  }

  stopAutoWeight() {
    if (this.autoWeightInterval) {
      clearInterval(this.autoWeightInterval);
      this.autoWeightInterval = null;
    }
  }
}
